import { Option, Value } from 'baseui/select';
import TableInput from 'components/elements/table/table-input';
import { ActionType } from 'components/elements/table/type';
import { differenceInCalendarDays, isSameDay } from 'date-fns';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import {
  HotelRescheduleDetailHotelFormType,
  HotelRescheduleFormType,
} from '../form-type';
import useGetHotelRescheduleDetailTableList from '../hooks/use-get-hotel-reschedule-detail-table-list';

interface Props {
  parentIndex: number;
  hotelRooms: Option[];
}

export default function NewHotelTable(props: Props) {
  const { control, trigger, getValues } =
    useFormContext<HotelRescheduleFormType>();
  const name = `hotelSales.${props.parentIndex}.hotelSaleHotels` as const;
  const { fields, update } = useFieldArray({
    control,
    name,
    keyName: '__customId',
  });
  const columns = useGetHotelRescheduleDetailTableList();

  const dispatch = React.useCallback(
    (action) => {
      const hotels = getValues(name);
      const currentRowIndex = action.rowIndex as number;
      const hotel = hotels[currentRowIndex];
      const type = action.type as ActionType;
      const columnId =
        action.columnId as keyof HotelRescheduleDetailHotelFormType;
      const value = action.value;
      const extra = action.extra as Value;

      const otherVal: () => Partial<HotelRescheduleDetailHotelFormType> =
        () => {
          if (columnId === 'checkIn') {
            const checkOutVal = hotel.checkOut;
            if (checkOutVal) {
              if (checkOutVal >= value) {
                return {
                  night: isSameDay(checkOutVal, value)
                    ? 1
                    : differenceInCalendarDays(checkOutVal, value),
                };
              }
            }
          }
          if (columnId === 'checkOut') {
            const checkInVal = hotel.checkIn;
            if (checkInVal) {
              if (checkInVal <= value) {
                return {
                  night: isSameDay(checkInVal, value)
                    ? 1
                    : differenceInCalendarDays(value, checkInVal),
                };
              }
            }
          }
          if (columnId === 'hotelRoomId') {
            return { hotelRoomName: extra?.[0]?.label as string };
          }
          return {};
        };

      if (type === 'update_cell') {
        update(currentRowIndex, {
          ...hotel,
          [columnId]: value,
          ...otherVal(),
        });
        trigger(name);
      }
    },
    [getValues, name, trigger, update],
  );

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns}
        data={fields}
        dispatch={dispatch}
        noAddRemoveRow
        name={name}
        uniqueRowKey="customId"
      />
    </div>
  );
}
